import { render } from "./new_friend_request_modal.vue?vue&type=template&id=757f7931"
import script from "./new_friend_request_modal.vue?vue&type=script&lang=js"
export * from "./new_friend_request_modal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__